import { render } from "./BalRadio.vue?vue&type=template&id=12bdc490&ts=true"
import script from "./BalRadio.vue?vue&type=script&lang=ts"
export * from "./BalRadio.vue?vue&type=script&lang=ts"

import "./BalRadio.vue?vue&type=style&index=0&id=12bdc490&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__